import {Box, Grid, GridProps} from '@mui/material';
import {memo} from 'react';
import styled from 'styled-components';
import {useSelector} from 'react-redux';
import {RootState} from '@store';

import BarImage from '../../../../assets/icons/DesktopBanner.png';
import JaideeBarImage from '../../../../assets/icons/JaideeBanner.png';

const RightBarWrapper = styled(Box)`
  && {
    height: 100%;
    position: fixed;
    padding: 0;
    right: 0;
  }
`;

const GridItem = styled(Grid)<GridProps>`
  && {
    @media (max-width: 480px) {
      display: none;
    }
  }
`;

function RightBar() {
  const {theme} = useSelector((state: RootState) => state.login);

  return (
    <GridItem item data-testid='right-bar'>
      <RightBarWrapper>
        {theme === 'boost' || theme === 'indrive' ? null : (
          <img
            src={theme === 'jaidee' ? JaideeBarImage : BarImage}
            alt='rightBar'
            width='100%'
            height='100%'
          />
        )}
      </RightBarWrapper>
    </GridItem>
  );
}

export default memo(RightBar);
